import { useAtom, useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useErrorMessage } from '@/core/i18n';
import { FieldRow, HOVER_QUERY, InfoTip, SegmentedControl, useMediaQuery } from '@/core/ui';
import { useUnitFormatter } from '@/features/units';
import { WIND_RAMP_MAX } from '../model/windColors';
import { loadStatusAtom, stationsVisibilityAtom } from '../state/atoms';

/** How to read a station's circle, behind an "i" button next to the field's label. */
function StationsHelp() {
  const { t } = useTranslation('stations');
  const fmt = useUnitFormatter();
  const hover = useMediaQuery(HOVER_QUERY);
  return (
    <InfoTip label={t('help')}>
      {t(hover ? 'legend.mouse' : 'legend.touch', {
        unit: fmt.speedSymbol,
        max: fmt.speedValue(WIND_RAMP_MAX),
      })}
    </InfoTip>
  );
}

function LoadError() {
  const status = useAtomValue(loadStatusAtom);
  const errorMessage = useErrorMessage();
  return (
    <p className="pb-2 text-sm text-red-700 empty:pb-0" role="status">
      {status.kind === 'error' && errorMessage(status.error)}
    </p>
  );
}

/** Shows or hides the weather stations, with a load error while shown. */
export function StationsField() {
  const { t } = useTranslation('stations');
  const [visibility, setVisibility] = useAtom(stationsVisibilityAtom);
  return (
    <div>
      <FieldRow group label={t('label')} info={<StationsHelp />}>
        <SegmentedControl
          compact
          className="min-w-[130px]"
          options={[
            { value: 'off', label: t('off') },
            { value: 'on', label: t('on') },
          ]}
          value={visibility}
          onChange={setVisibility}
        />
      </FieldRow>
      {visibility === 'on' && <LoadError />}
    </div>
  );
}
